import { createApp } from 'vue';
import App from './App.vue';
import router from './router/index';
import vuetify from './plugins/vuetify';
import { loadFonts } from './plugins/webfontloader';
import VueGoogleMaps from '@fawmi/vue-google-maps';
import cartStore from './stores/cart';
import axios from 'axios';
import { createPinia } from 'pinia'; // 👈 Importar Pinia

loadFonts();

const app = createApp(App);

// Proveer el carrito globalmente
app.provide('cartStore', cartStore);

app.use(router);
app.use(vuetify);
app.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyB-I6et1AftzkN3O-k4Czgh90TF1I_GH20',
    libraries: 'places',
  },
});

// 🔹 Registrar Pinia
const pinia = createPinia();
app.use(pinia);

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js')
    .then((registration) => {
      console.log('Service Worker registrado con éxito:', registration);
    })
    .catch((error) => {
      console.error('Error al registrar el Service Worker:', error);
    });
}

// Interceptor global de axios
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

const baseURL = window.location.protocol === 'capacitor:' 
   'https://mvexpress.mx'

axios.defaults.baseURL = baseURL;

app.mount('#app');
